import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { LORP_RETURN_SUMMARY } from '@src/constants';
import SummaryStep from './SummaryStep';
export var LORPNextSteps = function () {
    return (React.createElement("div", { className: "lg:sui-w-1/2" },
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(Typography, { variant: "h3" }, "Your next steps...")),
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(SummaryStep, { number: 1, title: LORP_RETURN_SUMMARY.STEP_1_TITLE, texts: [LORP_RETURN_SUMMARY.STEP_1_SUB] })),
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(SummaryStep, { number: 2, title: LORP_RETURN_SUMMARY.STEP_2_TITLE, texts: [LORP_RETURN_SUMMARY.STEP_2_SUB] })),
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(SummaryStep, { number: 3, title: LORP_RETURN_SUMMARY.STEP_3_TITLE, texts: [LORP_RETURN_SUMMARY.STEP_3_SUB] }))));
};
